import store from '@/store';
import { findModule } from '@/stores/appModule';

export const setModule = function set(name) {
  const module = findModule(name);
  store.dispatch('appModules/SETMODULE', module);
};

function buildDateString(daysToGoBack) {
  const d = new Date();
  d.setDate(d.getDate() - daysToGoBack);
  const dd = (`0${d.getDate()}`).slice(-2);
  const mm = (`0${d.getMonth() + 1}`).slice(-2);
  const yyyy = d.getFullYear();
  const date = `${yyyy}-${mm}-${dd}`;
  return date;
}

function ensureArray(prop) {
  return (Array.isArray(prop)) ? prop : Array.of(prop);
}

function getCepTab(route) {
  if (route.path.includes('population')) {
    return 'population';
  }
  if (route.path.includes('Submission')) {
    return 'electionsSubmission';
  }
  if (route.path.includes('Recalculate')) {
    return 'electionsRecalculate';
  }
  if (route.path.includes('lealist')) {
    return 'lealist';
  }
  return '';
}

export default [
  {
    path: '/directMatch',
    name: 'directMatch',
    redirect: 'directMatch/dashboard',
    component: () => import(/* webpackChunkName: "directmatch" */ '@/views/DirectMatch/DirectMatchRouterView.vue'),
    beforeEnter(to, from, next) {
      if (!store.getters.permissions.includes('DRMCH:APP:NAV:VIEW')) {
        next({
          name: 'notAuthorized',
        });
      } else {
        setModule('directMatch');
        if (to.meta.permission && !store.getters.permissions.includes(to.meta.permission)) {
          next({
            name: 'notAuthorized',
          });
        }
        next();
      }
    },
    children: [
      {
        path: 'dashboard',
        name: 'dmDashboard',
        meta: { title: 'DirectMatch: Dashboard' },
        props: true,
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/DirectMatch/Dashboard/Dashboard.vue'),
      },
      {
        path: 'cep',
        component: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepRouterView.vue'),
        meta: { permission: 'DRMCH:CEP:MGR:VIEW', title: 'DirectMatch: CEP Manager' },
        beforeEnter(to, from, next) {
          const route = Object.assign({}, to);
          if (!route.query.schoolYear) {
            route.query.schoolYear = store.state.propertiesModule.properties['CEP-CEP_CURRENT_SCHOOL_YEAR'];
            next(route);
          } else {
            next();
          }
        },
        props: route => ({
          cepTab: getCepTab(route),
          locationGroupId: route.query.locationGroupId,
          schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
        }),
        children: [
          {
            path: '',
            redirect: 'population',
          },
          {
            path: 'population',
            name: 'cepPopulation',
            meta: { permission: 'DRMCH:CEP:MGR:VIEW', title: 'DirectMatch: CEP Manager - Population' },
            components: {
              cepHeader: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepHeaderView.vue'),
              cepSummary: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepManagerSummarySection.vue'),
              cepYears: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerYears.vue'),
              cepBody: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerPopulationLocationSummary.vue'),
              cepInstructions: () => import(/* webpackChunkName: "cep" */ '@/components/CepInstructions.vue'),
            },
            props: {
              cepHeader: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepYears: route => ({
                locationGroupId: route.query.locationGroupId,
                path: route.path,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepSummary: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepBody: route => ({
                locationGroupId: route.query.locationGroupId,
                page: route.query.page ? Number(route.query.page) : null,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
                sortField: route.query.sortField,
                sortOrder: route.query.sortOrder,
              }),
            },
          },
          {
            path: 'population/:stateId',
            meta: { permission: 'DRMCH:CEP:MGR:VIEW', title: 'DirectMatch: CEP Manager - Population Details' },
            components: {
              cepHeader: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepHeaderView.vue'),
              cepSummary: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepManagerSummarySection.vue'),
              cepYears: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerYears.vue'),
              cepBody: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerPopulationDetails.vue'),
              cepInstructions: () => import(/* webpackChunkName: "cep" */ '@/components/CepInstructions.vue'),
            },
            props: {
              cepHeader: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepYears: route => ({
                locationGroupId: route.query.locationGroupId,
                path: route.path,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepSummary: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepBody: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
                stateId: Number(route.params.stateId),
                sortStudentsField: route.query.sortStudentsField,
                sortStudentsOrder: route.query.sortStudentsOrder,
              }),
            },
          },
          {
            path: 'electionsSubmission',
            meta: { permission: 'DRMCH:CEP:MGR:VIEW', title: 'DirectMatch: CEP Manager - Elections Submission' },
            components: {
              cepHeader: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepHeaderView.vue'),
              cepSummary: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepManagerSummarySection.vue'),
              cepYears: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerYears.vue'),
              cepBody: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerElectionsSummary.vue'),
              cepInstructions: () => import(/* webpackChunkName: "cep" */ '@/components/CepInstructions.vue'),
            },
            props: {
              cepHeader: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepYears: route => ({
                locationGroupId: route.query.locationGroupId,
                path: route.path,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepSummary: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepBody: route => ({
                locationGroupId: route.query.locationGroupId,
                page: route.query.page ? Number(route.query.page) : null,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
                sortField: route.query.sortField,
                sortOrder: route.query.sortOrder,
              }),
            },
          },
          {
            path: 'electionsRecalculate',
            meta: { permission: 'DRMCH:CEP:ELECTIONS:RECALCULATE', title: 'DirectMatch: CEP Manager - Elections Recalculate' },
            components: {
              cepHeader: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepHeaderView.vue'),
              cepSummary: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepManagerSummarySection.vue'),
              cepYears: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerYears.vue'),
              cepBody: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerRecalculate.vue'),
              cepInstructions: () => import(/* webpackChunkName: "cep" */ '@/components/CepInstructions.vue'),
            },
            props: {
              cepHeader: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepYears: route => ({
                disableYears: true,
                locationGroupId: route.query.locationGroupId,
                path: route.path,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepSummary: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepBody: route => ({
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
                sortField: route.query.sortField,
                sortOrder: route.query.sortOrder,
              }),
            },
          },
          {
            path: 'electionsSubmission/:stateId',
            meta: { permission: 'DRMCH:CEP:MGR:VIEW', title: 'DirectMatch: CEP Manager - Election Details' },
            components: {
              cepHeader: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepHeaderView.vue'),
              cepSummary: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepManagerSummarySection.vue'),
              cepYears: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerYears.vue'),
              cepBody: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerElectionsDetails.vue'),
              cepInstructions: () => import(/* webpackChunkName: "cep" */ '@/components/CepInstructions.vue'),
            },
            props: {
              cepHeader: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepYears: route => ({
                locationGroupId: route.query.locationGroupId,
                path: route.path,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
                cluster: Boolean(route.query.cluster),
                availableYears: route.query.years,
              }),
              cepSummary: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepBody: route => ({
                cepTab: getCepTab(route),
                cluster: Boolean(route.query.cluster),
                stateId: Number(route.params.stateId),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
                sortSitesField: route.query.sortSitesField,
                sortSitesOrder: route.query.sortSitesOrder,
                sortStudentsField: route.query.sortStudentsField,
                sortStudentsOrder: route.query.sortStudentsOrder,
              }),
            },
          },
          {
            path: 'lealist',
            name: 'cepLeaList',
            meta: { permission: 'DRMCH:CEP:MGR:LEA:VIEW', title: 'DirectMatch: CEP Manager - LEA List' },
            components: {
              cepHeader: () => import(/* webpackChunkName: "cep" */ '@/views/DirectMatch/CEP/cepHeaderView.vue'),
              cepYears: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerYears.vue'),
              cepBody: () => import(/* webpackChunkName: "cep" */ '@/components/CepManagerPopulationSummary.vue'),
              cepInstructions: () => import(/* webpackChunkName: "cep" */ '@/components/CepInstructions.vue'),
            },
            props: {
              cepHeader: route => ({
                cepTab: getCepTab(route),
                locationGroupId: route.query.locationGroupId,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepYears: route => ({
                locationGroupId: route.query.locationGroupId,
                path: route.path,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : null,
              }),
              cepBody: route => ({
                cepTab: getCepTab(route),
                page: route.query.page ? Number(route.query.page) : null,
                schoolYear: route.query.schoolYear ? Number(route.query.schoolYear) : Number(this.$store.state.propertiesModule.properties['CEP-CEP_CURRENT_SCHOOL_YEAR']),
                sortField: route.query.sortField,
                sortOrder: route.query.sortOrder,
                populationStatus: route.query.populationStatus
                  ? ensureArray(route.query.populationStatus) : [],
                electionStatus: route.query.electionStatus
                  ? ensureArray(route.query.electionStatus) : [],
              }),
              cepInstructions: route => ({
                cepTab: getCepTab(route),
              }),
            },
          },
        ],
      },
      {
        path: 'locations/:id',
        component: () => import(/* webpackChunkName: "locations" */ '@/views/DirectMatch/Locations/LocationProfile.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'directMatchLocationDetails',
            meta: { title: 'DirectMatch: Location Profile' },
            component: () => import(/* webpackChunkName: "locations" */ '@/views/DirectMatch/Locations/LocationProfileDetails.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'matchHistory',
        name: 'matchHistory',
        meta: { permission: 'DRMCH:MATCH:HISTORY:VIEW', title: 'DirectMatch: Match History' },
        component: () => import(/* webpackChunkName: "matchHistory" */ '@/views/DirectMatch/MatchHistory/MatchHistory.vue'),
        children: [
          {
            path: 'batches',
            name: 'matchHistoryBatches',
            meta: { permission: 'DRMCH:MATCH:HISTORY:VIEW', title: 'DirectMatch: Match History - Batches' },
            component: () => import(/* webpackChunkName: "matchHistory" */ '@/views/DirectMatch/MatchHistory/Batches.vue'),
            props: (route) => {
              const {
                sortField,
                sortOrder,
                batchId,
                endDate,
                page,
                startDate,
                districtCode = [],
                programCode = [],
                matchTypeIds = [],
                status = [],
                schoolCode = [],
                schoolYear = [],
              } = route.query;

              return {
                sortField,
                sortOrder,
                batchId,
                endDate,
                page,
                startDate,
                districtCodes: ensureArray(districtCode),
                programCodes: ensureArray(programCode),
                matchTypeId: ensureArray(matchTypeIds).map(Number),
                status: ensureArray(status),
                schoolCodes: ensureArray(schoolCode),
                schoolYear: ensureArray(schoolYear),
              };
            },
            beforeEnter(to, from, next) {
              const route = Object.assign({}, to);
              if (!route.query.schoolYear) {
                route.query.schoolYear = store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
                next(route);
              }
              if (!route.query.batchId && !route.query.startDate) {
                route.query.startDate = buildDateString(29);
                next(route);
              }
              next();
            },
          },
          {
            path: 'transactions',
            name: 'matchHistoryTransactions',
            meta: { permission: 'DRMCH:MATCH:HISTORY:VIEW', title: 'DirectMatch: Match History - Transactions' },
            component: () => import(/* webpackChunkName: "matchHistory" */ '@/views/DirectMatch/MatchHistory/Transactions.vue'),
            props: (route) => {
              const {
                sortField,
                sortOrder,
                batchId,
                dmMatchTransId,
                endDate,
                page,
                pageNum,
                startDate,
                districtCode = [],
                programCode = [],
                matchTypeIds = [],
                status = [],
                schoolCode = [],
                schoolYear = [],
              } = route.query;

              return {
                sortField,
                sortOrder,
                batchId,
                dmMatchTransId,
                endDate,
                page,
                pageNum,
                startDate,
                districtCodes: ensureArray(districtCode),
                programCodes: ensureArray(programCode),
                matchTypeId: ensureArray(matchTypeIds).map(Number),
                status: ensureArray(status),
                schoolCodes: ensureArray(schoolCode),
                schoolYear: ensureArray(schoolYear),
              };
            },
            beforeEnter(to, from, next) {
              const route = Object.assign({}, to);
              if (!route.query.schoolYear) {
                route.query.schoolYear = store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
                next(route);
              }
              if (!route.query.dmMatchTransId && !route.query.batchId && !route.query.startDate) {
                route.query.startDate = buildDateString(29);
                next(route);
              }
              next();
            },
          },
        ],
      },
      {
        path: 'matchOptions',
        name: 'matchOptionsDirectMatch',
        props: true,
        component: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsRouterView.vue'),
        meta: { permission: 'DRMCH:MATCH:OPTIONS:VIEW', title: 'DirectMatch: Match Options' },
        beforeEnter(to, from, next) {
          if (to.name === 'matchOptionsDirectMatch') {
            const routes = [
              {
                name: 'dmMatchOptionsPerson',
                permission: 'DRMCH:MATCH:OPTIONS:PERSONTAB:VIEW',
              },
              {
                name: 'dmMatchOptionsAddress',
                permission: 'DRMCH:MATCH:OPTIONS:ADDRESS:VIEW',
              },
            ];
            const availableRoutes = routes
              .find(route => store.getters.permissions.includes(route.permission));

            if (!availableRoutes) {
              next({ name: 'notAuthorized' });
            }
            next({ name: availableRoutes.name });
          }
          next();
        },
        children: [
          {
            path: 'person',
            name: 'dmMatchOptionsPerson',
            meta: { permission: 'DRMCH:MATCH:OPTIONS:PERSONTAB:VIEW', title: 'DirectMatch: Match Options - Person' },
            components: {
              matchOptionsSelection: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsPerson.vue'),
            },
            beforeEnter(to, from, next) {
              if (to.name === 'dmMatchOptionsPerson') {
                const routes = [
                  {
                    name: 'dmMatchOptionsPersonPersonId',
                    permission: 'DRMCH:MATCH:OPTIONS:PERSONID',
                  },
                  {
                    name: 'dmMatchOptionsPersonUpload',
                    permission: 'DRMCH:MATCH:OPTIONS:UPLOADFILE',
                  },
                  {
                    name: 'dmMatchOptionsPersonIndividual',
                    permission: 'DRMCH:MATCH:OPTIONS:INDIVIDUALMATCH',
                  },
                  {
                    name: 'dmMatchOptionsPersonManual',
                    permission: 'DRMCH:MATCH:OPTIONS:MANUALMATCH',
                  },
                ];
                const availableRoutes = routes
                  .find(route => store.getters.permissions.includes(route.permission));

                if (!availableRoutes) {
                  next({ name: 'notAuthorized' });
                }
                next({ name: availableRoutes.name });
              }
              next();
            },
            children: [
              {
                path: 'person',
                name: 'dmMatchOptionsPersonPersonId',
                meta: { permission: 'DRMCH:MATCH:OPTIONS:PERSONID', title: 'DirectMatch: Match Options - Person ID' },
                components: {
                  matchOptionsPersonForm: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsPersonId.vue'),
                  matchOptionsSearchResults: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsMatchResults.vue'),
                },
              },
              {
                path: 'upload',
                name: 'dmMatchOptionsPersonUpload',
                meta: { permission: 'DRMCH:MATCH:OPTIONS:UPLOADFILE', title: 'DirectMatch: Match Options - Upload File' },
                components: {
                  matchOptionsPersonForm: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsUpload.vue'),
                  matchOptionsSearchResults: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsMatchResults.vue'),
                },
                props: {
                  matchOptionsPersonForm: {
                    matchTypeCode: 'FILE',
                  },
                },
              },
              {
                path: 'individual',
                name: 'dmMatchOptionsPersonIndividual',
                meta: { permission: 'DRMCH:MATCH:OPTIONS:INDIVIDUALMATCH', title: 'DirectMatch: Match Options - Individual Match' },
                components: {
                  matchOptionsPersonForm: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsIndividual.vue'),
                  matchOptionsSearchResults: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsMatchResults.vue'),
                },
                props: {
                  matchOptionsPersonForm: {
                    matchTypeCode: 'INDIV',
                  },
                },
              },
              {
                path: 'manual',
                name: 'dmMatchOptionsPersonManual',
                meta: { permission: 'DRMCH:MATCH:OPTIONS:MANUALMATCH', title: 'DirectMatch: Match Options - Manual Authorization' },
                components: {
                  matchOptionsPersonForm: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsManual.vue'),
                  matchOptionsSearchResults: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsManualMatchResults.vue'),
                },
                props: {
                  matchOptionsPersonForm: route => ({
                    matchTypeCode: 'MANL',
                    studentId: route.query.studentId,
                  }),
                  matchOptionsSearchResults: route => ({
                    matchTypeCode: 'MANL',
                    studentId: route.query.studentId,
                  }),
                },
              },
            ],
          },
          {
            path: 'address',
            name: 'dmMatchOptionsAddress',
            meta: { permission: 'DRMCH:MATCH:OPTIONS:ADDRESS:VIEW', title: 'DirectMatch: Match Options - Address Match' },
            components: {
              matchOptionsSelection: () => import(/* webpackChunkName: "dmMatchOptions" */ '@/views/DirectMatch/MatchOptions/MatchOptionsAddress.vue'),
            },
          },
        ],
      },
      {
        path: 'matchoptions-address',
        name: 'addressoptions',
        props: true,
        component: () => import(/* webpackChunkName: "matchoptions" */ '@/views/DirectMatch/MatchOptions/AddressOptions.vue'),
        meta: { permission: 'DRMCH:MATCH:OPTIONS:ADDRESS:VIEW', title: 'DirectMatch: Match Options - Address Match' },
      },
      {
        path: 'nearMatches',
        name: 'directMatchNearMatches',
        component: () => import(/* webpackChunkName: "matchoptions" */ '@/views/DirectMatch/MatchOptions/NearMatches.vue'),
        props: (route) => {
          const {
            dmBatchId,
            dmMatchTransId,
            endDate,
            identifier,
            page,
            startDate,
            districtCode = [],
            identifierType = [],
            matchType = [],
            programCode = [],
            schoolCode = [],
            schoolYear = [],
            sortField,
            sortOrder,
          } = route.query;

          return {
            dmBatchId,
            dmMatchTransId,
            endDate,
            identifier,
            page: Number(page),
            startDate,
            districtCode: ensureArray(districtCode),
            identifierType: ensureArray(identifierType),
            matchType: ensureArray(matchType),
            programCode: ensureArray(programCode),
            schoolCode: ensureArray(schoolCode),
            schoolYear: ensureArray(schoolYear),
            sortField,
            sortOrder,
          };
        },
        meta: { permission: 'DRMCH:MATCH:RESOLVENM:VIEW', title: 'DirectMatch: Near Match List' },
      },
      {
        path: 'compare/:nearMatchId',
        name: 'directMatchCompareMatches',
        component: () => import(/* webpackChunkName: "matchoptions" */ '@/views/DirectMatch/MatchOptions/CompareMatches.vue'),
        props: true,
        meta: { permission: 'DRMCH:MATCH:RESOLVENM:VIEW', title: 'DirectMatch: Near Match Compare' },
      },
      {
        path: 'studentIdentifier/:identifier',
        component: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/StudentIdentifier.vue'),
        props: true,
        children: [
          {
            path: 'directMatch',
            name: 'DmStudentIdentifierDirectMatch',
            components: {
              studentIdentifierHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/StudentIdentifierHeaderView.vue'),
              studentIdentifierBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/StudentIdentifierDirectMatch.vue'),
            },
          },
        ],
      },
      {
        path: 'personProfile/:id',
        component: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfile.vue'),
        props: true,
        meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW' },
        beforeEnter: (to, from, next) => {
          // Only proceed with query modification if 'retired' is not 'true'
          // and avoid recursion if query already matches the intended state
          if (to.query.retired !== 'true' && to.query.retired !== 'false') {
            const newQuery = { ...to.query, retired: 'false' };
            // Check if the query is already set to 'false' to prevent unnecessary redirect
            if (JSON.stringify(newQuery) !== JSON.stringify(to.query)) {
              next({ path: to.path, query: newQuery }); // Re-trigger with the updated query
            } else {
              next(); // Proceed if no change is necessary
            }
          } else {
            next(); // Proceed as usual if 'retired' is 'true' or 'false'
          }
        },
        children: [
          {
            path: 'overview',
            name: 'DmOverview',
            meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Overview' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileOverview.vue'),
            },
            props: {
              personProfileBody: true,
            },
          },
          {
            path: 'masterRecord',
            name: 'DmMasterRecord',
            meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Record' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterRecord.vue'),
            },
            props: {
              personProfileBody: true,
            },
            children: [
              {
                path: 'masterLocationInfoDetails',
                name: 'DmMasterLocationInfoDetails',
                meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Location Information' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterLocationInfoDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'addNote',
                name: 'DmAddNote',
                meta: { permission: ['DRMCH:PRPRF:NOTES:ADD:GENERAL', 'DRMCH:PRPRF:NOTES:ADD:ADMIN'], title: 'Person Profile: Add a Note' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterAddNote.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'addLocation',
                name: 'DmAddLocation',
                meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Add Location' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileMasterAddLocation.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
            ],
          },
          {
            path: 'historyRecords',
            name: 'DmHistoryRecords',
            meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: History Records' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHistoryRecords.vue'),
            },
            props: {
              personProfileBody: true,
            },
            children: [
              {
                path: 'historyRecordDetails',
                name: 'DmHistoryRecordDetails',
                meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: History Record Details' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHistoryRecordDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'historyLocationInfoDetails',
                name: 'DmHistoryLocationInfoDetails',
                meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Location Information' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHistoryLocationInfoDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
            ],
          },
          {
            path: 'associatedRecords',
            name: 'DmAssociatedRecords',
            meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Associated Records' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileAssociatedRecords.vue'),
            },
            props: {
              personProfileBody: true,
            },
            children: [
              {
                path: 'associatedRecordDetails',
                name: 'DmAssociatedRecordDetails',
                meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Associated Record Details' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileAssociatedRecordDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
              {
                path: 'associatedLocationInfoDetails',
                name: 'DmAssociatedLocationInfoDetails',
                meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: Master Location Information' },
                components: {
                  personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
                  personProfileSubBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileAssociatedLocationInfoDetails.vue'),
                },
                props: {
                  personProfileSubBody: true,
                },
              },
            ],
          },
          {
            path: 'directMatch',
            name: 'DmPersonProfileDirectMatch',
            meta: { permission: 'DRMCH:PRPRF:PROFILE:VIEW', title: 'Person Profile: DirectMatch' },
            components: {
              personProfileHeader: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileHeaderView.vue'),
              personProfileBody: () => import(/* webpackChunkName: "personProfile" */ '@/views/PersonProfile/PersonProfileDirectMatch.vue'),
            },
            props: {
              personProfileBody: route => ({
                id: route.params.id,
                sortField: route.query.sortField,
                sortOrder: route.query.sortOrder,
                personProfileBody: true,
              }),
            },
          },
        ],
      },
      {
        path: 'search',
        name: 'directMatchSearch',
        component: () => import(/* webpackChunkName: "dmSearch" */ '@/views/DirectMatch/Search.vue'),
        props: (route) => {
          const {
            sortField,
            sortOrder,
            page,
            id,
            districtCode = [],
            programCode = [],
            schoolCode = [],
            schoolYear,
          } = route.query;

          return {
            sortField,
            sortOrder,
            page,
            id,
            districtCodes: ensureArray(districtCode),
            programCodes: ensureArray(programCode),
            schoolCodes: ensureArray(schoolCode),
            schoolYear,
          };
        },
        meta: { permission: 'DRMCH:SRCH:OPTIONS:VIEW', title: 'DirectMatch: Search Options' },
        beforeEnter(to, from, next) {
          const route = Object.assign({}, to);
          const { query } = route;
          if (
            !query.schoolYear
            || (!query.districtCode && store.getters.userDistricts.length === 1)
          ) {
            if (!query.schoolYear) {
              query.schoolYear = store.state.propertiesModule
                .properties['RULE-CURRENT_SCHOOL_YEAR'];
            }
            if (!query.districtCode && store.getters.userDistricts.length === 1) {
              query.districtCode = [store.getters.userDistricts[0].code];
            }
            if (!query.schoolCode && store.getters.userSchools.length === 1) {
              query.schoolCode = [`${store.getters.userSchools[0].code}:${store.getters.userDistricts[0].code}`];
            }
            next(route);
          }
          next();
        },
      },
      {
        path: 'searchdownload',
        name: 'directMatchSearchDownload',
        component: () => import(/* webpackChunkName: "dmSearch" */ '@/views/DirectMatch/SearchDownload.vue'),
        props: (route) => {
          const {
            page,
            id,
            districtCode = [],
            programCode = [],
            schoolCode = [],
            schoolYear,
          } = route.query;
          const {
            totalCount,
          } = route.params;

          return {
            page,
            id,
            districtCodes: ensureArray(districtCode),
            programCodes: ensureArray(programCode),
            schoolCodes: ensureArray(schoolCode),
            schoolYear,
            totalCount,
          };
        },
        meta: { permission: 'DRMCH:SRCH:OPTIONS:PRSN:SRCH', title: 'DirectMatch: Search Profile - Download' },
      },
      {
        path: 'reports',
        props: true,
        component: () => import(/* webpackChunkName: "reports" */ '@/views/ReportsMyActivity.vue'),
        children: [
          {
            // UserProfile will be rendered inside User's <router-view>
            // when /user/:id/profile is matched
            path: '',
            name: 'reportsmaind',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/Reports.vue'),
            meta: { permission: 'DRMCH:REP:VIEW', title: 'DirectMatch: Reports' },
          },
        ],
      },
      {
        path: 'reportdescriptions',
        props: true,
        component: () => import(/* webpackChunkName: "reports" */ '@/views/ReportDescriptions.vue'),
        children: [
          {
            path: 'customizefns834report',
            name: 'customizefns834report',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/DirectMatch/Report/Fns834Report.vue'),
            meta: { permission: 'DRMCH:REP:FNS834', title: 'DirectMatch: FNS-834 Report' },
          },
          {
            path: 'customizepopulationreport',
            name: 'customizepopulationreport',
            props: true,
            component: () => import(/* webpackChunkName: "reports" */ '@/views/DirectMatch/Report/PopulationReport.vue'),
            meta: { permission: 'DRMCH:REP:POP', title: 'DirectMatch: Population Data Report' },
          },
        ],
      },
      {
        path: 'ruleManager',
        name: 'DmRuleManager',
        meta: { permission: 'SYS:SYS:RULEMGR:VIEW' },
        redirect: { name: 'DmRuleManagerPersonId' },
        component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerHeader.vue'),
        props: true,
        children: [
          {
            path: 'personId',
            name: 'DmRuleManagerPersonId',
            meta: { title: 'Rule Manager: Person ID' },
            component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerPersonId.vue'),
            props: true,
          },
          {
            path: 'directMatch',
            name: 'DmRuleManagerDirectMatch',
            meta: { title: 'Rule Manager: DirectMatch' },
            component: () => import(/* webpackChunkName: "ruleManager" */ '@/views/RuleManager/RuleManagerDirectMatch.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'addOption',
        name: 'DMAddUser',
        component: () => import(/* webpackChunkName: "user" */ '@/views/Users/AddUser.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:USRMGR:ADD', title: 'Security Manager: Add Options' },
      },
      {
        path: 'securityManager',
        name: 'DMSecurityManager',
        meta: { title: 'Security Manager' },
        component: () => import(/* webpackChunkName: "securityManager" */ '@/views/SecurityManager/SecurityManager.vue'),
        props: (route) => {
          const {
            sortField,
            sortOrder,
            page,
            search,
            isActive,
            role = [],
            districtCode = [],
            schoolCode = [],
            group = [],
            status = [],
          } = route.query;

          return {
            sortField,
            sortOrder,
            page,
            search,
            isActive: Boolean(isActive),
            roleCodes: ensureArray(role),
            districtCodes: ensureArray(districtCode),
            schoolCodes: ensureArray(schoolCode),
            groupCodes: ensureArray(group),
            statuses: ensureArray(status),
          };
        },
      },
      {
        path: 'user/:id',
        name: 'DMUser',
        component: () => import(/* webpackChunkName: "user" */ '@/views/Users/UserProfile.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:USRMGR:VIEW', title: 'Security Manager: User Profile' },
      },
      {
        path: 'roles/:roleId',
        name: 'DMSecurityManagerHeader',
        component: () => import(/* webpackChunkName: "securtiyManager" */ '@/components/SecurityManagerHeader.vue'),
        props: true,
        meta: { permission: 'SYS:SEC:ROLEMGR:VIEW' },
        children: [
          {
            path: 'details',
            name: 'DMSecurityManagerDetails',
            component: () => import(/* webpackChunkName: "securtiyManager" */ '@/views/SecurityManager/SecurityManagerDetails.vue'),
            props: true,
            meta: { permission: 'SYS:SEC:ROLEMGR:VIEW', title: 'Security Manager: Role Profile - Details' },
          },
          {
            path: 'privileges',
            name: 'DMSecurityManagerPrivilege',
            component: () => import(/* webpackChunkName: "securtiyManager" */ '@/views/SecurityManager/SecurityManagerPrivilege.vue'),
            props: true,
            meta: { permission: 'SYS:SEC:ROLEMGR:VIEW', title: 'Security Manager: Role Profile - Privileges' },
          },
        ],
      },
      {
        path: 'districtInfo/:code',
        name: 'DmDistrictInfo',
        component: () => import(/* webpackChunkName: "districtInfo" */ '@/views/DistrictInfo/DistrictInfoHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'DmDistrictInfoDetails',
            meta: { title: 'District Profile: Details' },
            component: () => import(/* webpackChunkName: "districtInfo" */ '@/views/DistrictInfo/DistrictInfoDetails.vue'),
            props: true,
          },
          {
            path: 'download-options',
            name: 'DmDistrictInfoDownloadOptions',
            component: () => import(/* webpackChunkName: "districtInfo" */ '@/views/DistrictInfo/DistrictInfoDownloadOptions.vue'),
            props: true,
            meta: { permission: 'DRMCH:DWNLD:DOWNLOAD', title: 'District Profile: Download' },
          },
        ],
      },
      {
        path: 'schoolInfo/:districtCode/:schoolCode',
        name: 'DmSchoolInfo',
        component: () => import(/* webpackChunkName: "schoolInfo" */ '@/views/SchoolInfo/SchoolInfoHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'DmSchoolInfoDetails',
            meta: { title: 'School Profile: Details' },
            component: () => import(/* webpackChunkName: "schoolInfo" */ '@/views/SchoolInfo/SchoolInfoDetails.vue'),
            props: true,
          },
          {
            path: 'download-options',
            name: 'DmSchoolInfoDownloadOptions',
            component: () => import(/* webpackChunkName: "schoolInfo" */ '@/views/SchoolInfo/SchoolInfoDownloadOptions.vue'),
            props: true,
            meta: { permission: 'DRMCH:DWNLD:DOWNLOAD', title: 'School Profile: Download' },
          },
        ],
      },
      {
        path: 'configurationManager',
        name: 'DMConfigurationManager',
        redirect: { name: 'DMSystemConfiguration' },
        component: () => import(/* webpackChunkName: "configurationManager" */ '@/views/Configuration/ConfigurationManagerRouterView.vue'),
        meta: { permission: 'SYS:SYS:CONFIGMGR:VIEW' },
        beforeEnter(to, from, next) {
          if (to.name === 'DMConfigurationManager') {
            const routes = [
              {
                name: 'DMSystemConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:VIEW',
              },
              {
                name: 'DMDirectMatchConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:DRMCHTAB',
              },
              {
                name: 'DMPersonIdConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:PRSIDTAB',
              },
              {
                name: 'DMDataMartsConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:DATAMARTTAB',
              },
              {
                name: 'DMScheduleConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:SCHEDTAB',
              },
              {
                name: 'DMIntegrationConfiguration',
                permission: 'SYS:SYS:CONFIGMGR:INTEGRATIONTAB',
              },
            ];
            const availableRoutes = routes
              .find(route => store.getters.permissions.includes(route.permission));

            if (!availableRoutes) {
              next({ name: 'DMNotAuthorized' });
            }
            next({ name: availableRoutes.name });
          }
          next();
        },
        children: [
          {
            path: 'system',
            name: 'DMSystemConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:VIEW', title: 'Configuration Manager: System' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "systemConfiguration" */ '@/views/Configuration/ConfigurationSystemRouterView.vue'),
            },
          },
          {
            path: 'personId',
            name: 'DMPersonIdConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:PRSIDTAB', title: 'Configuration Manager: Person ID' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "personIdConfiguration" */ '@/views/Configuration/ConfigurationPersonIdRouterView.vue'),
            },
          },
          {
            path: 'directmatch',
            name: 'DMDirectMatchConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:DRMCHTAB', title: 'Configuration Manager: DirectMatch' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "directMatchConfiguration" */ '@/views/Configuration/ConfigurationDirectMatchRouterView.vue'),
            },
          },
          {
            path: 'datamarts',
            name: 'DMDataMartsConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:DATAMARTTAB', title: 'Configuration Manager: Data Marts' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "datamartsConfiguration" */ '@/views/Configuration/ConfigurationDataMartsRouterView.vue'),
            },
          },
          {
            path: 'schedule',
            name: 'DMScheduleConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:SCHEDTAB', title: 'Configuration Manager: Schedule' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "scheduleConfiguration" */ '@/views/Configuration/ConfigurationScheduleRouterView.vue'),
            },
          },
          {
            path: 'integration',
            name: 'DMIntegrationConfiguration',
            meta: { permission: 'SYS:SYS:CONFIGMGR:INTEGRATIONTAB', title: 'Configuration Manager: Integration' },
            components: {
              configurationManagerSelection: () => import(/* webpackChunkName: "integrationConfiguration" */ '@/views/Configuration/ConfigurationIntegrationRouterView.vue'),
            },
          },
        ],
      },
      {
        path: 'batch/:batchId',
        redirect: { name: 'DMBatchInfoDetails' },
        component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/DirectMatch/BatchProfile/DmBatchProfileHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'DMBatchInfoDetails',
            meta: { title: 'DirectMatch: Batch Profile - Details' },
            component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/DirectMatch/BatchProfile/DmBatchProfileDetails.vue'),
          },
          {
            path: 'download',
            name: 'DMBatchInfoDownload',
            component: () => import(/* webpackChunkName: "BatchInfo" */ '@/views/DirectMatch/BatchProfile/DmBatchProfileDownload.vue'),
            props: true,
            meta: { permission: 'DRMCH:DWNLD:DOWNLOAD', title: 'DirectMatch: Batch Profile - Download' },
          },
        ],
      },
      {
        path: 'transactions/:transactionId',
        name: 'DMTransactionInfoHeader',
        redirect: { name: 'DMTransactionInfoDetails' },
        component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views/DirectMatch/TransactionProfile/DmTransactionProfileHeader.vue'),
        props: true,
        children: [
          {
            path: 'details',
            name: 'DMTransactionInfoDetails',
            meta: { title: 'DirectMatch: Transaction Profile - Details' },
            component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views/DirectMatch/TransactionProfile/DmTransactionProfileDetails.vue'),
            props: true,
          },
          {
            path: 'download',
            name: 'DMTransactionInfoDownload',
            meta: { title: 'DirectMatch: Transaction Profile - Download' },
            component: () => import(/* webpackChunkName: "TransactionInfo" */ '@/views//DirectMatch/TransactionProfile/DmTransactionProfileDownload.vue'),
            props: route => ({
              // studentIdentifier: route.query.identifier,
              transactionId: route.params.transactionId,
            }),

          },
        ],
      },
      {
        path: '*',
        component: () => import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue'),
      },
    ],
  },
];
